import { useEffect, useRef } from "react";
import { useOnlineStatus } from "../../../hooks/useOnlineStatus";
import { useApp } from "../../../shared/AppProvider/AppProvider";

const NetworkStatusNotifier = () => {
  const isOnline = useOnlineStatus();
  const { notify } = useApp();
  const prevStatus = useRef<boolean | null>(null); // track previous status

  useEffect(() => {
    if (prevStatus.current === null) {
      // first render, just set previous status
      prevStatus.current = isOnline;
      return;
    }

    if (!isOnline && prevStatus.current) {
      // went offline
      notify(
        "error",
        "You are offline",
        "Some features may not work until you reconnect to the internet."
      );
    } else if (isOnline && !prevStatus.current) {
      // came back online
      notify(
        "success",
        "Back online",
        "You are reconnected to the internet."
      );
    }

    prevStatus.current = isOnline; // update previous status
  }, [isOnline, notify]);

  return null;
};

export default NetworkStatusNotifier;